import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import { FETCH_STATS_HIGHS, setSeasonHighs, setStatsHighs } from '../actions';

/**
 * @typedef {object} fetchStatsHighsAction
 * @property {object} payload
 * @property {import('../../types').LastRoundHighsStatsType} type
 * @property {string} payload.id
 */

/**
 * @param {fetchStatsHighsAction} action - The Redux action.
 */
export function* fetchStatsHighs(action) {
    const { type, id } = action.payload;

    let data = {};

    if (type === 'round') {
        data = yield call(
            fetchWithMisToken,
            `${PULSE.app.environment.statsPro}/leadingPlayerMatchTotals/round/${id}`
        );

        yield put(setStatsHighs(data));
    } else {
        data = yield call(
            fetchWithMisToken,
            `${PULSE.app.environment.statsPro}/leadingPlayerMatchTotals/season/${id}`
        );

        yield put(setSeasonHighs(data));
    }

    yield put(FETCH_STATS_HIGHS.success(data));
}
